<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มกลุ่มพนักงานใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ taEmployeeGroupInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle> Employee Group </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <tabs class="mt-2" @selectedTab="handleSelectedTab">
          <tab
            title="ข้อมูลทั่วไป"
            class="px-4"
            style="background-color: white"
          >
            <div>
              <label class="body-2">
                คำอธิบาย (ไทย)
                <span class="red--text"><strong>*</strong></span>
              </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="taEmployeeGroup.title_th"
                :rules="[(v) => !!v || 'โปรดระบุคำอธิบาย']"
                outlined
                dense
                required
                clearable
                @change="checkEmpty($event, 'title_th')"
              >
              </v-text-field>
            </div>
            <div>
              <label class="body-2"> คำอธิบาย (อังกฤษ) </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                v-model="taEmployeeGroup.title_en"
                outlined
                dense
                clearable
                @change="checkEmpty($event, 'title_en')"
              >
              </v-text-field>
            </div>
          </tab>
          <tab
            title="พนักงานในกลุ่ม"
            class="pt-0 px-4"
            style="background-color: white"
          >
            <div v-if="formAction === 'add' && !isShowTaEmployeeGroupAdd">
              กรุณาเพิ่มข้อมูลทั่วไปก่อน
            </div>
            <div v-else>
              <v-row>
                <v-col class="py-0" cols="12" lg="6">
                  <label class="caption"> ค้นหา </label>
                  <v-text-field
                    v-model="search"
                    class="fix-google-chrome"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    clearable
                    @input="handleSearchTaEmployee"
                    hide-details
                  >
                  </v-text-field
                ></v-col>
                <v-col class="py-0" cols="12" lg="6">
                  <label class="caption"> หน่วยงาน </label>
                  <v-autocomplete
                    v-model="taOrganizationFilter"
                    class="fix-google-chrome"
                    :items="taOrganizations"
                    item-text="title_th"
                    item-value="organization_uuid"
                    hide-details
                    outlined
                    dense
                    clearable
                    @change="handleFilterTaOrganization"
                  >
                  </v-autocomplete
                ></v-col>
              </v-row>
              <div class="d-lg-flex justify-space-between align-baseline mb-4">
                <div>
                  <button type="button" @click="$emit('onClickAddTaEmployee')">
                    <v-icon left small color="primary">mdi-plus</v-icon>
                    <span class="caption primary--text">
                      เพิ่มพนักงานในกลุ่ม
                    </span>
                  </button>
                </div>
                <div style="width: 200px">
                  <v-select
                    style="font-size: 14px"
                    v-model="sort"
                    :disabled="pagination.isLoading"
                    prepend-inner-icon="mdi-sort-ascending"
                    :items="sorts"
                    hide-details
                    @change="handleChangeSort"
                  ></v-select>
                </div>
              </div>
            </div>
            <DynamicScroller
              :items="taEmployeesGroupMember"
              :min-item-size="pagination.limit"
              key-field="employee_uuid"
            >
              <template v-slot="{ item, index, active }">
                <DynamicScrollerItem
                  :item="item"
                  :active="active"
                  :data-index="index"
                >
                  <v-card
                    color="#f5f5f5"
                    outlined
                    class="d-flex align-center mb-2"
                    v-observe-visibility="
                      item.employee_uuid === lastEmployee.employee_uuid &&
                      !isLastPage
                        ? infiniteScrollHandler
                        : false
                    "
                  >
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 360px"
                          >
                            {{ item.firstname_th }} {{ item.lastname_th }} [{{
                              item.employee_code
                            }}]
                          </span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 360px"
                          >
                            {{ item.organization.title_th }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <div class="px-2">
                      <v-btn
                        icon
                        @click="handleDeleteTaEmployeeGroupMember(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-card>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
            <div v-if="pagination.isLoading">
              <v-card
                color="#f5f5f5"
                v-for="num in 2"
                :key="num"
                outlined
                class="mb-2 px-4 py-2"
              >
                <Skeleton width="200px" />
                <Skeleton :count="1" />
              </v-card>
            </div>
          </tab>
        </tabs>
      </div>
      <v-toolbar flat color="blue-grey lighten-4" v-if="selectedTab === 0">
        <v-row
          justify="center"
          align="center"
          v-if="
            (!isTaEmployeeGroupDataChange && formAction === 'edit') ||
            (formAction === 'add' && isShowTaEmployeeGroupAdd)
          "
        >
          <v-btn icon @click="onDelete">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn class="primary mr-3" depressed v-else @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteMember"
      :loading="confirmDialogDeleteLoadingMember"
      :dialogData="confirmDialogDeleteDataMember"
      @cancelConfirmDialog="cancelConfirmDialogDeleteMember"
      @submitConfirmDialog="submitConfirmDialogDeleteMember"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
    Tab,
    Tabs,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    taEmployeeGroup: {
      type: Object,
    },
    taEmployeeGroupInit: {
      type: Object,
    },
  },
  watch: {
    taEmployeeGroup(item) {
      if (item.employee_group_uuid) {
        this.taEmployeesGroupMember = []
        this.pagination.currentPage = 1
        this.getTaEmployeesGroupMember()
      }
    },
  },
  data() {
    return {
      selectedTab: 0,
      isShowTaEmployeeGroupAdd: false,
      taOrganizationFilter: '',
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      taEmployeesGroupMember: [],
      totalTaEmployeesGroupMember: 0,
      sort: 'firstname_th,asc',
      sorts: [
        { id: 1, text: 'เรียงตามชื่อ (ก - ฮ)', value: 'firstname_th,asc' },
        {
          id: 2,
          text: 'เรียงตามรหัส',
          value: 'employee_code,asc',
        },
        {
          id: 3,
          text: 'เรียงตามหน่วยงาน',
          value: 'organization_th,asc',
        },
      ],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDeleteMember: false,
      confirmDialogDeleteLoadingMember: false,
      confirmDialogDeleteDataMember: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    lastEmployee() {
      const [lastItem] = this.taEmployeesGroupMember.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalTaEmployeesGroupMember / this.pagination.limit)
      )
    },
    taOrganizations() {
      return this.$store.state.organization.organizations
    },
    isTaEmployeeGroupDataChange() {
      if (
        this.taEmployeeGroup.title_th !== this.taEmployeeGroupInit.title_th ||
        this.taEmployeeGroup.title_en !== this.taEmployeeGroupInit.title_en
      ) {
        this.$emit('isTaEmployeeGroupDataChange', true)
        return true
      }
      this.$emit('isTaEmployeeGroupDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      fetchTaEmployeesGroupMember:
        'taEmployeesGroup/fetchTaEmployeesGroupMember',
      deleteTaEmployeeGroupMember:
        'taEmployeesGroup/deleteTaEmployeeGroupMember',
      addTaEmployeeGroup: 'taEmployeesGroup/addTaEmployeeGroup',
      editTaEmployeeGroup: 'taEmployeesGroup/editTaEmployeeGroup',
      deleteTaEmployeeGroup: 'taEmployeesGroup/deleteTaEmployeeGroup',
    }),
    handleSelectedTab(i) {
      this.selectedTab = i
    },
    handleDeleteTaEmployeeGroupMember(item) {
      this.confirmDialogDeleteMember = true
      this.confirmDialogDeleteDataMember = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบพนักงาน',
        value: `${item.firstname_th} ${item.lastname_th}`,
        item,
      }
    },
    cancelConfirmDialogDeleteMember() {
      this.confirmDialogDeleteMember = false
    },
    async submitConfirmDialogDeleteMember({ employee_uuid }) {
      try {
        this.search = ''
        this.confirmDialogDeleteLoadingMember = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.taEmployeeGroup.employee_group_uuid,
          employee_uuid,
        }

        await this.deleteTaEmployeeGroupMember(payload)
        this.confirmDialogDeleteLoadingMember = false
        this.confirmDialogDeleteMember = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.taEmployeesGroupMember = []
        this.pagination.currentPage = 1
        await this.getTaEmployeesGroupMember()
        this.$store.commit('taEmployeesGroup/EDIT_TA_EMPLOYEE_GROUP', {
          ...this.taEmployeeGroup,
          employee_group_member: {
            ...this.taEmployeeGroup.employee_group_member,
            total: this.totalTaEmployeesGroupMember,
          },
        })
      } catch (error) {
        this.confirmDialogDeleteLoadingMember = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleFilterTaOrganization() {
      this.taEmployeesGroupMember = []
      this.pagination.currentPage = 1
      this.getTaEmployeesGroupMember()
    },
    handleSearchTaEmployee: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.taEmployeesGroupMember = []
      this.pagination.currentPage = 1
      this.getTaEmployeesGroupMember()
    }, 1000),
    handleChangeSort() {
      this.taEmployeesGroupMember = []
      this.pagination.currentPage = 1
      this.getTaEmployeesGroupMember()
    },
    async getTaEmployeesGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          employee_group_uuid: this.taEmployeeGroup.employee_group_uuid,
          query: {
            organization_uuid: this.taOrganizationFilter || undefined,
            search: this.search || undefined,
            sort: this.sort,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
          },
        }
        const {
          total: totalTaEmployeesGroupMember,
          data: taEmployeesGroupMember,
        } = await this.fetchTaEmployeesGroupMember(payload)
        this.totalTaEmployeesGroupMember = totalTaEmployeesGroupMember
        this.setTaEmployeesGroupMember(taEmployeesGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextTaEmployeesGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getTaEmployeesGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setTaEmployeesGroupMember(taEmployeesGroupMember) {
      this.taEmployeesGroupMember = [
        ...this.taEmployeesGroupMember,
        ...taEmployeesGroupMember,
      ]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextTaEmployeesGroupMember()
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.taEmployeeGroup[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบกลุ่มพนักงาน',
        value: this.taEmployeeGroup.title_th,
        item: this.taEmployeeGroup,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete({ employee_group_uuid }) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_group_uuid,
      }

      this.deleteTaEmployeeGroup(payload)
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
          this.sort = 'firstname_th,asc'
          this.taEmployeesGroupMember = []
          this.isShowTaEmployeeGroupAdd = false
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: {
              title_th: this.taEmployeeGroup.title_th,
              title_en: this.taEmployeeGroup.title_en || undefined,
            },
          }

          const taEmployeeGroup = await this.addTaEmployeeGroup(payload)
          this.$emit('addTaEmployeeGroupSuccess', taEmployeeGroup)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.isShowTaEmployeeGroupAdd = true
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            employee_group_uuid: this.taEmployeeGroup.employee_group_uuid,
            body: {
              title_th: this.taEmployeeGroup.title_th,
              title_en: this.taEmployeeGroup.title_en || undefined,
            },
          }

          await this.editTaEmployeeGroup(payload)
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
          this.sort = 'firstname_th,asc'
          this.taEmployeesGroupMember = []
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    onClose() {
      if (this.isTaEmployeeGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
        this.sort = 'firstname_th,asc'
        this.taEmployeesGroupMember = []
        this.isShowTaEmployeeGroupAdd = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      this.sort = 'firstname_th,asc'
      this.taEmployeesGroupMember = []
      this.isShowTaEmployeeGroupAdd = false
    },
    onReset() {
      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
      this.sort = 'firstname_th,asc'
      this.isShowTaEmployeeGroupAdd = false
    },
  },
}
</script>
